export const BLOCK_LABELS = Object.freeze([
  "草甸草方块", "暖土方块", "岛石方块", "浅沙方块", "软雪方块", "清水方块",
  "花园小径", "原木方块", "晒白木板", "炉火砖块", "雾玻璃", "暖光石砖",
] as const);
